import RequestVolumeTail from "@/components/RequestVolumeTail";

const RequestsAnalyticsLiveTail = () => (
  <RequestVolumeTail variant="embedded" className="mb-2 mt-2 shrink-0 sm:mb-3 sm:mt-3" />
);

export default RequestsAnalyticsLiveTail;
